export const enum StorageKey {
  AUTH_ACCESS_TOKEN = "tokens",
  MEDIA = "media",
  NOT_SHOWN_POPUP = "",
  IS_CONTINUOUS_LOADING = "isContinuousLoading",
  LAST_UPDATED_AT = "lastUpdatedAt",
  IS_SHOWN_DATA_USAGE_POPUP = "isShownDataUsagePopup",
}
